// Mis comisiones del vendedor (`GET /commissions/me`): una sola consulta para Metas y Pagos.
import { useQuery } from '@tanstack/react-query';
import { commissionEngine } from '@/api/services/retail-commission/commissions.client';
import { useAuthStore } from '@/stores/authStore';

/** Cortes anteriores que se piden; el motor suma aparte el corte en curso. */
export const MY_COMMISSIONS_WEEKS = 8;

export function useMyCommissions() {
    // El motor responde por el token: la clave lleva al usuario para no servirle a otro su caché.
    const userId = useAuthStore((state) => state.user?.cognitoSub ?? null);
    return useQuery({
        queryKey: ['sales', 'my-commissions', userId, MY_COMMISSIONS_WEEKS],
        queryFn: () => commissionEngine.getMine(MY_COMMISSIONS_WEEKS),
        staleTime: 60_000,
    });
}
